export enum EventFormPractice {
  UpdateForm = 'update',
}

export enum StatePractice {
  Open = '1',
  Draft = '0',
  Closed = '8',
  Suspended = '5',
}
